import { BookmarkType } from 'components/external-reference/bookmark/BookmarkDropdown';
import { instance } from 'api/api';
import { AxiosResponse } from 'axios';
import { APIResponse, DashboardElementType } from 'tools/types';
import { FilterType } from 'components/external-reference/Filter';

export const externalReportAPI = {
    bookmark: {
        getBaseUrl(elementId: number, elementType: DashboardElementType): string {
            let controller = 'reference';
            if (elementType == 'internal report') {
                controller = 'report';
            }
            return `data/${controller}/element/${elementId}`;
        },
        updateBookmark(
            elementId: number,
            elementType: DashboardElementType,
            segmentValueId: number,
            bookmark: BookmarkType,
            filtersJSON: string,
            distributionItemId?: number,
        ): Promise<AxiosResponse<APIResponse<BookmarkType>>> {
            const params: any = {
                bookmark: bookmark.id,
                name: bookmark.name,
                filters: filtersJSON,
                bookmarkType: bookmark.bookmarkType,
                bookmarkData: JSON.stringify(bookmark.bookmarkData),
            };
            if (distributionItemId) {
                params.distributionItemId = distributionItemId;
            }
            return instance.post(this.getBaseUrl(elementId, elementType) + `/${segmentValueId}/save-bookmark`, params);
        },
        deleteBookmark(elementId: number, elementType: DashboardElementType, bookmarkId: number) {
            return instance.post(this.getBaseUrl(elementId, elementType) + '/0/delete-bookmark', {
                bookmark: bookmarkId,
            });
        },
        duplicateBookmark(
            elementId: number,
            elementType: DashboardElementType,
            bookmarkId: number,
            distributionItemId?: number,
        ): Promise<AxiosResponse<APIResponse<BookmarkType>>> {
            return instance.post(this.getBaseUrl(elementId, elementType) + '/0/copy-bookmark', {
                bookmark: bookmarkId,
                item_id: distributionItemId ?? 0,
            });
        },
        sortBookmarks(
            elementId: number,
            elementType: DashboardElementType,
            bookmarks: Array<BookmarkType>,
            distributionItemId?: number,
        ) {
            const order: any = {};
            bookmarks.forEach((b, i) => (order[b.id] = i));
            const params: any = {
                order: JSON.stringify(order),
            };
            if (distributionItemId) {
                params.item_id = distributionItemId;
            }
            return instance.post(this.getBaseUrl(elementId, elementType) + '/0/update-bookmark-order', params);
        },
        saveFilters(elementId: number, segmentValueId: number, filters: Array<FilterType>) {
            const activeFilters = filters.filter((f) => f.canBeCached);

            if (activeFilters.length < 1 && segmentValueId <= 0) {
                return;
            }
            return instance
                .post(`data/viewer/element/${elementId}/segment/${segmentValueId}/save-filters`, {
                    filters: JSON.stringify(activeFilters),
                    type: 'element',
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    },
};
